import { createUseStyles } from '@glu/theming';

const styles = ({ readOnly, spacing: { unit }, typography, workflow: { footer } }) => ({
  alert: {
    padding: [24, 65, 0]
  },
  amount: {
    ...typography.mainTitle,
    color: 'black'
  },
  dropdown: {
    '& button': {
      whiteSpace: 'nowrap'
    }
  },
  footer: {
    ...footer,
    '& $section': {
      '&:first-child': {
        borderRight: '#CCCCCC 1px solid',
        paddingLeft: 0
      },
      padding: [0, 20]
    },

    '& [disabled]': {
      opacity: '.6'
    },

    // Hard code color
    borderTop: '#CCCCCC 1px solid',

    bottom: 0,
    left: 0,
    width: `calc(100% - ${15 * unit}px)`
  },
  inputs: {
    // IE 11 fix
    maxWidth: 340
  },
  readOnly: {
    ...readOnly,
    '& [id^=recurring-transfer][data-active=true]:disabled': {
      // TODO: Remove these styles after resolution of https://jira.bottomline.tech/browse/GLU-6498
      backgroundColor: '#0070B9 !important',
      color: '#fff'
    },
    '& [id^=recurring-transfer][data-active]:disabled': {
      textAlign: 'center'
    },
    '& [data-qa=end-complex-label], [class^=endSelected]': {
      marginLeft: -5
    }
  },
  memo: {
    fontSize: 14,
    wordWrap: 'break-word'
  },
  scheduler: {
    boxShadow: '0px 1px 8px rgba(0,0,0,0.1)',
    padding: [30, 70, 30, 30],
    width: 600
  },
  schedulerWeeklyFix: {
    // HACK: Day of week error message
    "& [data-qa='occurrence-recurring-transfer'] [class^='error']": {
      color: 'rgb(223, 0, 0)',
      fontSize: 1.5 * unit,
      marginBottom: 2 * unit
    }
  },
  section: {},
  sectionWrapper: {
    alignItems: 'center',
    display: 'flex',
    padding: [20, 0]
  },
  semiMonthly: {
    '& [data-qa=interval-type-select]': {
      '&, & + svg': {
        display: 'none'
      }
    }
  },
  wrapper: {
    '& $inputs > div > label': {
      width: 333
    },
    '& fieldset': {
      marginRight: 50
    },
    display: 'flex',
    flexWrap: 'wrap',
    margin: [68, 65, 20, 65]
  }
});

export default styles; // For HOC
export const useStyles = createUseStyles(styles); // For Hooks
